module.exports = __webpack_public_path__ + "img/5055c633-762d-458b-bb7f-f7823116143d.bb256eb4.png";